import React from 'react';

import cn from 'classnames';

import PropTypes from 'prop-types';

function RouteOverviewTreeItem({
  classNames,
  nodeDatum,
  toggleNode = () => null,
  onNodeClick = () => null,
  onNodeMouseOver = () => null,
  onNodeMouseOut = () => null,
  circleSize = 5,
  focusableNodes = true,
}) {
  return (
    <circle
      className={cn(classNames)}
      r={circleSize}
      onClick={(event) => {
        toggleNode();
        onNodeClick(event, nodeDatum);
      }}
      onKeyPress={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleNode();
          onNodeClick(event, nodeDatum);
        }
      }}
      onMouseOver={onNodeMouseOver}
      onMouseOut={onNodeMouseOut}
      tabIndex={focusableNodes ? 0 : -1}
    />
  );
}

RouteOverviewTreeItem.propTypes = {
  classNames: PropTypes.string,
  nodeDatum: PropTypes.any,
  toggleNode: PropTypes.func,
  onNodeClick: PropTypes.func,
  onNodeMouseOver: PropTypes.func,
  onNodeMouseOut: PropTypes.func,
  circleSize: PropTypes.number,
  focusableNodes: PropTypes.bool,
};

export default RouteOverviewTreeItem;
